import { render, staticRenderFns } from "./CouponRewardItem.vue?vue&type=template&id=311c6ed2&scoped=true&"
import script from "./CouponRewardItem.vue?vue&type=script&lang=js&"
export * from "./CouponRewardItem.vue?vue&type=script&lang=js&"
import style0 from "./CouponRewardItem.vue?vue&type=style&index=0&id=311c6ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c6ed2",
  null
  
)

export default component.exports